import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import AppContainer from './AppContainer'

const Root = ({ store }) => (
  <Provider store={store}>
    <React.Fragment>
      <AppContainer/>
    </React.Fragment>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
}

export default Root
